import { makeAutoObservable } from "mobx";

const initialState = {
  appLoaded: false,
};
export class MainStore {
  appLoaded = initialState.appLoaded;

  constructor() {
    makeAutoObservable(this);
  }

  setAppLoaded(appLoaded) {
    this.appLoaded = appLoaded;
  }
}
